<script>
import SetStatusForm from './SetStatusForm.vue'
/**
 * Dashboard component
 */
export default {
  components: {
    SetStatusForm,
  },
  data() {
    return {
      selectedRecord: null,
      fields: [
        {
          key: 'amount',
          sortable: true,
          label: 'مبلغ',
          thStyle: { width: '120px' },
          filter: {
            component: 'NumberFilter',
            operator: '$eq',
            value: '',
          },
        },
        {
          key: 'bank_account_name',
          sortable: false,
          label: 'نام کارت',
          thStyle: { width: '150px' },
          filter: {
            name: 'bankAccount.name',
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'bank_account_owner_name',
          sortable: false,
          label: 'نام صاحب کارت',
          thStyle: { width: '150px' },
          filter: {
            name: 'bankAccount.ownerName',
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'bank_account_cart_number',
          sortable: false,
          label: 'شماره کارت',
          thStyle: { width: '180px' },
          filter: {
            name: 'bankAccount.cardInfo',
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'bank_account_iban_number',
          sortable: false,
          label: 'شماره شبا',
          thStyle: { width: '180px' },
          filter: {
            name: 'bankAccount.iban_number',
            component: 'SearchFilter',
            operator: '$lk',
            value: '',
          },
        },
        {
          key: 'state',
          sortable: true,
          label: 'وضعیت',
          thStyle: { width: '180px' },
          filter: {
            component: 'SelectFilter',
            operator: '$in',
            value: [],
            items: [
              {
                value: 0,
                text: 'در حال بررسی',
              },
              {
                value: 1,
                text: 'ارسال برای پرداخت',
              },
              {
                value: 2,
                text: 'پرداخت شده',
              },
              {
                value: 3,
                text: 'رد شده',
              },
              {
                value: 4,
                text: 'تایید کد',
              },
            ],
          },
        },
        {
          key: 'reject_reason',
          sortable: false,
          label: 'علت رد شدن',
          thStyle: { width: '180px' },
        },
      ],
    }
  },
  methods: {
    showStatusModal(item) {
      this.selectedRecord = item.id
      this.$refs['status-modal'].show()
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      id="status-modal"
      ref="status-modal"
      hide-footer
      title="تعیین وضعیت"
    >
      <SetStatusForm :record-id="selectedRecord" />
    </b-modal>
    <crud-table
      create-route=""
      :columns="fields"
      vuex-prefix="transferRequests"
      create-role="Developer"
      fetch-address="transfer-requests"
    >
      <template #cell(amount)="data">
        {{ $helper.formatPrice(data.item.amount) }}
      </template>
      <template #cell(bank_account_name)="data">
        {{
          data.item.bank_account != null ? data.item.bank_account.name : '----'
        }}
      </template>
      <template #cell(bank_account_owner_name)="data">
        {{
          data.item.bank_account != null
            ? data.item.bank_account.ownerName
            : '----'
        }}
      </template>
      <template #cell(bank_account_cart_number)="data">
        {{
          data.item.bank_account != null
            ? data.item.bank_account.cardInfo
            : '----'
        }}
      </template>
      <template #cell(bank_account_iban_number)="data">
        {{
          data.item.bank_account != null
            ? data.item.bank_account.iban_number
            : '----'
        }}
      </template>
      <template #cell(state)="data">
        <button
          @click="$emit('request-token', data.item)"
          v-if="$store.state.auth.user.is_developer && data.item.state === 4"
          class="btn bg-warning text-white"
        >
          {{ data.item.state_text }}
        </button>
        <button
          v-else
          class="btn"
          :class="{
            'text-success': data.item.state === 2 || data.item.state === 1,
            'text-danger': data.item.state === 3,
            'text-primary': data.item.state === 0,
            'text-warning': data.item.state === 4,
          }"
        >
          {{ data.item.state_text }}
        </button>
      </template>
      <template #cell(actions)="data">
        <b-button
          v-if="$store.state.auth.user.is_admin && data.item.state != 4"
          size="sm"
          @click="showStatusModal(data.item)"
          variant="primary"
        >
          تعیین وضعیت
        </b-button>
      </template>
    </crud-table>
  </div>
</template>
